export default ["EUR", "NOK", "SEK"];
